import {FormattedNumber, IntlProvider} from "react-intl";
import React from "react";
import PropTypes from 'prop-types'

export function FormattedMoneyHideZero({amount, currency}) {
    if (Number(amount) === 0) {
        return null;
    }

    return <IntlProvider locale="en">
        <FormattedNumber
            value={amount / 100}
            style="currency"
            currency={currency}
            currencyDisplay="symbol"
        />
    </IntlProvider>
}

export function FormattedMoney({amount, currency}) {
    return <IntlProvider locale="en">
        <FormattedNumber
        value={amount / 100}
        style="currency"
        currency={currency}
        currencyDisplay="symbol"
    />
    </IntlProvider>
}

FormattedMoneyHideZero.propTypes = {
    amount: PropTypes.string.isRequired,
    currency: PropTypes.oneOf(['EUR', 'GBP', 'USD']).isRequired,
};